"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Metrics = exports.Counter = void 0;
exports.presetLabels = presetLabels;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
class Metrics {
  constructor() {
    (0, _defineProperty2.default)(this, "values", {});
    (0, _defineProperty2.default)(this, "metrics", {});
  }
  counter(name) {
    if (!this.metrics[name]) {
      this.metrics[name] = new Counter(this.values, name);
    }
    return this.metrics[name];
  }
}
exports.Metrics = Metrics;
function presetLabels(labels, metrics) {
  return Object.fromEntries(Object.entries(metrics).map(([key, val]) => {
    return [key, val.labels(labels)];
  }));
}

/**
 * A counter is a cumulative metric that represents a single numerical value that only ever goes up
 */
class Counter {
  constructor(values, name) {
    this.values = values;
    this.name = name;
  }
  inc(value) {
    this.increase("", value || 1);
  }
  labels(labels) {
    let serialized = Object.entries(labels).map(entry => entry.join(":")).join(",");
    return {
      inc: value => {
        this.increase(serialized, value || 1, labels);
      }
    };
  }
  increase(serializedLabel, value, labels) {
    let key = this.name + "!" + serializedLabel;
    let entry = this.values[key];
    if (!entry) {
      entry = {
        value,
        labels
      };
      this.values[key] = entry;
    }
    entry.value += value;
  }
}
exports.Counter = Counter;
//# sourceMappingURL=Metrics.js.map